export const areArraysEqual = <TItem>(
  left: readonly TItem[],
  right: readonly TItem[],
): boolean =>
  left.length === right.length &&
  left.every((item, index) => Object.is(item, right[index]));

export const groupBy = <TItem, TKey>(
  items: readonly TItem[],
  getKey: (item: TItem) => TKey,
): Map<TKey, TItem[]> => {
  const groups = new Map<TKey, TItem[]>();

  items.forEach((item) => {
    const key = getKey(item);
    const group = groups.get(key);

    if (group) {
      group.push(item);

      return;
    }

    groups.set(key, [item]);
  });

  return groups;
};
